import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { onlineManager } from '@tanstack/react-query'
import KohBusPayment from '@/components/make-booking/payment'
import useStepMutation from '@/hooks/useStepMutation'
import { BOOKING_STEPS } from '@/utils/constant'
import {
  getBankAccountsQueryOptions,
  getPaymentMethodsQueryOptions,
} from '@/queries/query/payment'
import { queryKeys } from '@/queries/keys'

export const Route = createFileRoute('/make-booking/$id/payment/')({
  loader: ({ context, params }) => {
    if (onlineManager.isOnline() && !context.isRestoring) {
      return [
        context.queryClient.ensureQueryData(
          getPaymentMethodsQueryOptions(params.id),
        ),
        context.queryClient.ensureQueryData(getBankAccountsQueryOptions()),
      ]
    }
    return [
      context.queryClient.getQueryData(queryKeys.payment.methods(params.id)),
      context.queryClient.getQueryData(queryKeys.payment.bankAccounts()),
    ]
  },
  component: RouteComponent,
})

function RouteComponent() {
  const bookingId = Route.useParams({
    select: (s) => s.id,
  })
  const { update } = useStepMutation()

  useEffect(() => {
    update.mutate({
      id: bookingId,
      step: BOOKING_STEPS.STEP_TRIP_DETAILS,
      type: 'booking',
    })
  }, [])

  return <KohBusPayment />
}
